import { Indicator } from 'client/voladeum/indicators/types';

export const indicator_default: Indicator = {
  indicator_name: 'Add Indicator',
  indicator_id: 0,
  identifier: '',
  color: '#fff',
  description: '',
  indicator_group_id: 0,
  indicator_group_name: '',
  indicator_category_id: 0,
  indicator_category_name: '',
  chart_type_id: 0,
  chart_type_name: '',
  python: '',
  parameters: {},
  uuid: '',
};
